import UxImg from '../assets/img/ux.png'
import GraphicImg from '../assets/img/graphic-designer.png'
import AppDevImg from '../assets/img/app-development.png'

export const ServicesData = {
	data: [
		{
			imageUrl: UxImg,
			title: 'UI/UX Design',
			description: 'A UI/UX designer\'s job is to create user-friendly interfaces that enable users to understand how to\n' +
				'use complex technical products. If you\'re passionate about the latest technology trends and devices,\n' +
				'you\'ll find great fulfillment in being involved in the design process for the next hot gadget.'
		},
		{
			imageUrl: GraphicImg,
			title: 'Graphic Design',
			description: 'Graphic designers create visual concepts, using computer software or by hand, to communicate ideas\n' +
				'that inspire, inform, and captivate consumers. They develop the overall layout and production design for\n' +
				'applications such as advertisements, brochures, magazines, and reports.'
		},
		{
			imageUrl: AppDevImg,
			title: 'App Development',
			description: 'Software developers create the computer applications that allow users to do specific tasks and the\n' +
				'underlying systems that run the devices or control networks.'
		},
	]
}
